<template>
  <div class="__wrapper">
    <div class="__head" :style="{
      height: header_height,
      'background-image': user.cover_picture
        ? 'url(' + $fullUrl('images/covers/' + user.cover_picture) + ')'
        : false,
    }"></div>
    <div class="__body" @scroll="onFeedScoll" :style="{ heightOld: body_height }">
      <div class="__container">
        <!-- Profile - tags feed section -->
        <div class="__section-center">
          <div class="section-center__layout">
            <!-- Left section -->
            <div class="layout__left" id="freaking-sticky">
              <div class="left-sidebar">
                <div class="__card lesss">
                  <div class="contact-card">
                    <div class="section">
                      <router-link to="/profile/consultant">
                        <img v-if="user.profile" :src="$fullUrl('images/profiles/' + user.profile)" />
                        <img v-else src="../assets/avatar.png" alt />
                      </router-link>
                      <router-link to="/profile/consultant">
                        <h2 v-if="isName">{{ user.names | validate }}</h2>
                      </router-link>

                      <span v-if="!isCustomer">{{
                        user.location | validate
                      }}</span>
                    </div>
                    <!-- <div
                      class="section sec"
                      v-if="user.available !== '' && !isCustomer"
                    >
                      <label
                        v-if="
                          user.available_from &&
                          user.available_from !== '0000-00-00'
                        "
                        >{{ user.available | validate }}</label
                      >
                      <span
                        v-if="
                          user.available_from &&
                          user.available_from !== '0000-00-00'
                        "
                        >{{ user.available_from | formatDate }}</span
                      >

                      <label v-else>Currently unavailable</label>
                    </div> -->
                  </div>
                </div>
                <div class="__card less">
                  <div class="__title">
                    <span>Hashtags</span>
                  </div>
                  <div class="__card_body">
                    <h3>Trending</h3>
                    <div class="__item" v-for="(tag, i) in getMeProfile.tags" :key="i"
                      :class="{ bold: $route.params.tag == tag.name }">
                      <label @click="getFeedsbyTag(tag.name)">#{{ tag.name | validate }}</label>
                      <label @click="getFeedsbyTag(tag.name)">{{
                        tag.feed_count | validate
                      }}</label>
                    </div>

                    <div class="reset-hashtag-widget" v-if="$route.params.tag">
                      <button class="btn-clear-hashtag" @click="clearHashtag()">
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
                <div class="alumni-widget less">
                  <!-- <button class="btn-alumni">
                    <img src="@/assets/admin-icon/alumni.svg" /> Go to Alumni
                  </button> -->
                </div>
                <div class="__suggestion-box">
                  <div class="__card_body">
                    <div class="vertical">
                      <span @click="$router.push({
                        name: 'settings',
                        params: { tab: 'terms' },
                      })
                        ">Terms & Conditions</span>
                      <img width="60%" src="@/assets/icons/logo_gray.svg" />

                      <!-- <span>Consultified @ 2021</span> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="forum-widget">
                  <a target="_blank" href="https://forum.meritios.com/" class="forum-btn">Forum</a>
                </div>-->
              </div>
            </div>
            <!-- End of left section -->
            <!-- Feed section -->
            <div class="layout__right">
              <div class="box">
                <div class="post-tabs">
                  <div class="tab-item feed-tab" :class="{ active: tab_type === 'feed' }" @click="switchTab('feed')">
                    Feed
                  </div>
                  <div class="tab-item ass-tab" :class="{ active: tab_type === 'ass' }"
                    @click="switchTab('ass'), getInternship('init')">
                    Assignment
                  </div>
                </div>
                <!-- Post new widget-->
                <div class="__post-box" v-if="tab_type === 'feed'">
                  <div class="input__post">
                    <textarea placeholder="What’s on your mind?" ref="postText" v-model="postData.text"
                      id="new-post-textarea" :class="{ new: $route.query.new == 'true' }"></textarea>
                  </div>
                  <div class="post" v-if="postData.imageUrl">
                    <img :src="postData.imageUrl" />
                  </div>
                  <div class="__actions" v-if="postData.imageUrl">
                    <button class="btn-cancel" @click="removeImagee">
                      Cancel
                    </button>
                    <button class="btn-post" :class="{
                      disabled: !postData.text && !postData.imageUrl,
                    }" @click="savePost">
                      Post
                      <img src="@/assets/icons/arrowup.svg" alt="" />
                    </button>
                  </div>
                  <div class="__actions" v-if="!postData.imageUrl">
                    <button @click="pickImageFile(false)" class="btn-select">
                      <img src="@/assets/icons/add-image.svg" />
                      Add Image
                    </button>
                    <button class="btn-post" :class="{
                      disabled: !postData.text && !postData.imageUrl,
                    }" @click.stop="savePost">
                      Post
                    </button>
                  </div>
                  <input type="file" style="display: none" ref="image" accept="image/*" @change="onImagePicked" />
                  <input type="file" style="display: none" ref="video" accept="video/*" @change="onVideoPicked" />
                </div>
                <!-- End of Post new widget-->
              </div>
              <!-- List of post -->
              <div id="posts" v-if="tab_type === 'feed' &&
                !showFeedLoading &&
                feedsData &&
                feedsData.data.length > 0
                ">
                <div class="__post-item" v-for="(post, i) in feedsData.data" :key="i">
                  <div class="__header">
                    <div class="group">
                      <img v-if="post.user && post.user.profile_picture" :src="$fullUrl(
                        'images/profiles/' + post.user.profile_picture
                      )
                        " @click="gotoProfile(post.user, 'people')" />
                      <img v-else src="../assets/avatar.png" @click="gotoProfile(post.user, 'people')" />
                      <div class="__time">
                        <label class="__green" v-if="post.user">{{ post.user.first_name | validate }}
                          {{ post.user.last_name | validate }}</label>
                        <span v-if="!post.sponsored">{{
                          post.created_at | best
                        }}</span>
                        <span v-else>Today</span>
                      </div>
                    </div>
                    <div class="options">
                      <!-- Dropdown for customer  -->
                      <dropdown-menu v-if="post.user_id === userId">
                        <ul>
                          <li>
                            <a href @click.prevent="editPost(post)">Edit</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Post" ask="Are you sure you want to permanently delete this post?"
                              yesText="Delete" noText="Cancel" yesBtnClass="btn-danger"
                              @onComfirm="deletePost(post.id, i)">
                              <a href="#">Delete</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>
                      <!-- End of dropdown -->

                      <div class="items" v-show="post.showOption">
                        <span>Delete</span>
                      </div>
                    </div>
                  </div>
                  <div class="__paragraph">
                    <div class="feed-content" v-html="post.feed" v-linkified></div>
                    <img v-if="post.image" :src="$fullUrl('images/feeds/' + post.image)" />
                    <video v-if="post.video" controls>
                      <source :src="$fullUrl('videos/feeds/' + post.video)" />
                      Your browser is out of date.
                    </video>
                  </div>
                  <div class="__actions">
                    <div class="__likes">
                      <button class="btn-like" @click="feedLike(post)">
                        <img class="like-img" src="@/assets/icons/liked.svg" v-if="post.liked" />
                        <img v-else class="like-img" src="@/assets/icons/like.svg" />
                      </button>
                      <div class="likes-widget" @click="showLikes(post.likes)">
                        <div class="likes-profile" v-for="(like, index) in post.likes" :key="index"
                          v-if="index < 5 && like.user">
                          <img class="profile-image" :class="{
                            many: index > 0 && post.likes.length > 1,
                          }" v-if="like.user.profile_picture" :src="$fullUrl(
  'images/profiles/' + like.user.profile_picture
)
  " />
                          <img class="profile-image" :class="{
                            many: index > 0 && post.likes.length > 1,
                          }" v-else src="../assets/avatar.png" />
                          <span class="names" v-if="post.likes.length < 1">
                            {{ like.user.first_name | validate }}
                            {{ like.user.last_name | validate }}</span>
                        </div>
                      </div>
                      <span class="likes-left-count" v-if="post.likes.length > 4">
                        and
                        <span @click="showLikes(post.likes)" class="link">{{ post.likes.length - 4 }}
                          {{
                            post.likes.length - 4 > 1 ? "others" : "other"
                          }}</span>
                      </span>
                    </div>
                    <div class="_comments">
                      <button @click="showComment(post)" class="btn-comments" :class="{ active: post.showComment }">
                        <img v-if="!post.showComment" src="@/assets/icons/comments.svg" class="comment" />
                        <img v-else src="@/assets/icons/comments-active.svg" class="comment" />
                      </button>
                      <span v-if="post.comments.length > 0">{{
                        post.comments.length
                      }}</span>
                    </div>
                  </div>

                  <div class="__comments" v-if="post.comments &&
                      post.showComment &&
                      post.comments.length > 0
                      " id="comment-parent">
                    <div class="__coment" v-for="(c, i) in post.comments" v-if="c.user" :key="i">
                      <img v-if="c.user && c.user.profile_picture" :src="$fullUrl('images/profiles/' + c.user.profile_picture)
                        " @click="gotoProfile(c.user, 'people')" />
                      <img v-else src="../assets/avatar.png" @click="gotoProfile(c.user, 'people')" />
                      <div class="__text">
                        <h6 class="__green">
                          {{ c.user.first_name | validate }}
                          {{ c.user.last_name | validate }}
                          <span>{{
                            c.created_at
                            | moment("add", "2 hours")
                            | moment("from")
                          }}</span>
                        </h6>
                        <p>{{ c.comment | validate }}</p>
                        <div class="__actions">
                          <span class="__green" @click="commentLike(c)">
                            <span class="__green">Like</span>
                            <span class="__green" v-show="c.likes.length">{{
                              c.likes.length | validate
                            }}</span>
                          </span>
                          <!--<span class="__green">.</span>-->
                          <!--<span class="__green">Reply</span>-->
                        </div>
                        <div class="comment-dropdown" v-if="userId === c.user.id">
                          <button @click="removeComment(c.id, i, post.comments)">
                            <img src="@/assets/icons/red_delete.svg" alt />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="__comments-wrapper" v-if="post.showComment">
                    <div class="__comment__post-box">
                      <img v-if="getMeProfile.user && getMeProfile.user.profile_picture
                        " :src="$fullUrl(
    'images/profiles/' +
    getMeProfile.user.profile_picture
  )
    " />
                      <img v-else src="../assets/avatar.png" alt />
                      <textarea placeholder="Leave a Comment" v-model="post.text"
                        @keyup.enter="saveComment(post.text, i, post)"></textarea>
                      <input type="file" style="display: none" ref="image2" accept="image/*" @change="onImagePicked2" />
                      <input type="file" style="display: none" ref="video2" accept="video/*" @change="onVideoPicked2" />
                    </div>
                  </div>
                </div>
              </div>
              <div id="posts" v-if="tab_type === 'feed' &&
                !showFeedLoading &&
                feedsData &&
                feedsData.data.length == 0
                ">
                <div class="not-found" style="padding: 50px 0px">
                  <widgetNotFoundWidget title="Feed is currently unavailable, please check back for updates.">
                    <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
                  </widgetNotFoundWidget>
                </div>
              </div>
              <div v-if="showFeedLoading" class="feed-loading-widget">
                <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="showFeedLoading"
                  :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
              </div>
              <!-- End of list of post -->

              <!-- Start of Assignment -->
              <div class="all-assignment" v-if="tab_type === 'ass'">
                <div class="all-assignment-container">
                  <div class="assignments-header">
                    <div class="search-add-btn-widget">
                      <div class="search-widget">
                        <img src="@/assets/icons/search.svg" alt />
                        <input type="text" @keyup="searchInternship" placeholder="Type in to Search…" />
                      </div>
                      <div class="search-options"></div>
                    </div>
                    <div class="filter-widget">
                      <div class="filter-widget-header">
                        <div @click="show_lia_filters = !show_lia_filters" class="row left-section">
                          <label>More filters</label>
                          <img v-if="!show_lia_filters" src="@/assets/icons/allow-down.svg" />
                          <img v-else src="@/assets/icons/allow-up.svg" />
                        </div>
                      </div>
                      <div v-if="show_lia_filters" class="filter-widget-body row align-start">
                        <widgetFeedFilterTags placeholder="Search tag" @onSubmit="onSearchInternshipByTag">
                        </widgetFeedFilterTags>
                        <div class="h-spacer"></div>
                        <widgetFeedFilterLocation placeholder="Search location" @onSubmit="onSearchInternshipByLocation">
                        </widgetFeedFilterLocation>
                      </div>

                      <div class="filter-reset" v-if="isFilteringIntern && show_lia_filters">
                        <button class="btn btn-clear-filter" @click="clearAllFilters()">
                          Clear Filters
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="assingment-body">
                    <div v-if="internship_data && internship_data.data.length > 0" class="assignments-items">
                      <internshipItem v-for="(item, index) in internship_data.data" :item="item" :key="index" type="feed"
                        :class="{ active: false }" @onContact="message(item)">
                      </internshipItem>

                      <div class="internship-loading-widget">
                        <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="showLoading"
                          :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
                      </div>
                    </div>
                    <div v-else class="not-found" style="padding: 50px 0px">
                      <widgetNotFoundWidget title="No Assignment found">
                        <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
                      </widgetNotFoundWidget>
                    </div>
                  </div>



                </div>
              </div>
              <!-- End of of Assignment -->
            </div>
            <!-- End of feed swction -->
          </div>
        </div>
        <!-- End of Profile - tags feed section -->

        <!-- Banner section -->
        <div class="__section-right">
          <div class="long right-sidebar">

            <a href="http://yellowelk.se/kontakta-oss/" target="_blank">
              <img src="../assets/ads/image_1.png" />
            </a>
            <a href="http://www.carthiel.com/contact/" target="_blank">
              <img src="../assets/ads/image_2.jpg" />
            </a>
          </div>
        </div>
        <!-- End Banner section -->
      </div>
    </div>
    <template>
      <div class="overlay" v-if="showReactions" @click.self="showReactions = false">
        <div class="card__body">
          <div class="header">
            <h2>All likes ({{ likes.length | validate }})</h2>
            <button @click="showReactions = false" class="btn-close">
              &times;
            </button>
          </div>
          <div class="body">
            <div class="item" v-for="(like, index) in likes" :key="index + 'sjks'">
              <img v-if="like.user && like.user.profile_picture"
                :src="$fullUrl('images/profiles/' + like.user.profile_picture)" />
              <img v-else src="../assets/avatar.png" alt />
              <div class="user-info">
                <p class="names" v-if="like.user">
                  {{ like.user.first_name | validate }}
                  {{ like.user.last_name | validate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- feed modal -->
    <modals type="feed" />
    <!-- End of feed modal -->

    <!-- Edit post modal -->
    <template>
      <div class="overlay" v-if="showPostEdit" @click.self="(showPostEdit = false), resetPost()">
        <div class="edit-post-widget">
          <!-- Post new widget-->
          <div class="__post-box" :class="{ error: isEmpty }">
            <div class="input__post">
              <textarea placeholder="What’s on your mind?" v-model="editPostData.text" id="new-post-textarea"></textarea>
            </div>
            <div class="post" v-if="editPostData.imageUrl">
              <img :src="editPostData.imageUrl" />
              <div class="post-cancel">
                <button @click="removeImage">Cancel</button>
                <button @click="saveEditedPost">
                  <img src="@/assets/icons/feed_post_btn.svg" width="64" alt />
                </button>
              </div>
            </div>
            <div class="__actions" v-if="!editPostData.imageUrl">
              <div class="icons">
                <div class="__icon" @click.stop="pickImageFile(false)">
                  <img src="@/assets/icons/image.svg" />
                </div>
              </div>
              <div class="btn-post" @click.stop="saveEditedPost">
                <img src="@/assets/icons/feed_post_btn.svg" width="40" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- End of edit post modal -->

    <!-- Chat section -->
    <div class="floater">
      <chat :stranger="newChat"></chat>
    </div>
    <!-- Chat section -->

    <!-- Share modal -->
    <share-helper v-if="show_share_modal" @onClose="show_share_modal = false" :url="share_info.url"
      :title="share_info.title" :description="share_info.description" />
    <addPrivateInternshipModal v-if="show_add_private_lia_modal" @close="show_add_private_lia_modal = false"
      @success="show_add_private_lia_modal = false"></addPrivateInternshipModal>

    <!--  Add private lia dialog  -->
    <widgetModal v-if="show_add_private_lia_dialog_modal" :title="'Create Assignment'" :subtitle="''"
      btnlefttext="Create Assignment" btncentertext="Cancel" :leftloading="false" :rightloading="false"
      :centerloading="false" :footerhidden="false" footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 20px 31px" body_padding="0px 30px" width="550px" :hiderightbtn="true"
      @onLeftClick="createPrivateLia()" @onCenterClick="show_add_private_lia_dialog_modal = false">
      <div class="widget-modal-body-noscoll">
        <p>
          When you create your private Assignment you cannot choose another Assignment and
          your teacher will be informed of your choice.
        </p>
        <widgetCheckbox v-model="dont_show_again_private_lia_dialog" title="Don’t show this again"></widgetCheckbox>
      </div>
    </widgetModal>
  </div>
</template>

<script>
import "vue-slider-component/theme/default.css";
import { mapGetters, mapActions } from "vuex";
import imageCompression from "browser-image-compression";
import Chat from "../components/Chat/Chat";
import { eventBus } from "../main";
import Modals from "@/components/Dialog/Modals.vue";
import dropdownMenu from "../components/Partials/dropdownMenu";
import widgetFeedFilterTags from "@/components/widgets/widgetFeedFilterTags.vue";
import internshipItem from "@/views/feed/component/internship_item.vue";
import addPrivateInternshipModal from "@/views/feed/component/add_private_internship_modal.vue";
// import Vue from 'vue';
// Vue.forceUpdate();
import {
  API,
  GET_PROFILE_FEEDS_URL,
  GET_FEEDS_POSTS_URL,
  POST_FEED_POST_URL,
  GET_MORE_FEEDS_POSTS_URL,
  POST_FEED_COMMENT_URL,
  POST_FEED_LIKE_URL,
  DELETE_FEED_POST_URL,
  TAG_FEED_POST_URL,
} from "../Store/variable";
import axios from "axios";
export default {
  name: "Feeds",
  components: {
    Chat,
    Modals,
    dropdownMenu,
    widgetFeedFilterTags,
    internshipItem,
    addPrivateInternshipModal,
  },
  data() {
    return {
      newChat: {},
      show_lia_filters: false,
      show_add_private_lia_dialog_modal: false,
      dont_show_again_private_lia_dialog: false,
      show_add_private_lia_modal: false,
      show_share_modal: false,
      share_info: {
        url: "",
        title: "Hello there",
        description: "This is a description",
      },
      internship_data: [],
      showLoading: false,
      body_height: "calc(100% - 55px)",
      header_height: "55px",
      sticky: false,
      isFetching: false,
      reRender: true,
      showReactions: false,
      likes: [],
      availability_value: 0,
      colorCache: {},
      isEmpty: false,
      options: {
        dotSize: 14,
        width: "50%",
        height: 5,
        railStyle: {
          backgroundColor: "#22B573",
        },
        processStyle: {
          backgroundColor: "#1995A8",
        },
      },
      chatCollapsed: false,
      postData: {
        thumbnail: false,
        thumbnail2: false,
        imageFile: null,
        imageName: "",
        imageUrl: "",
        videoFile: null,
        text: "",
        tags: [],
        user_id: null,
      },
      showPostEdit: false,
      editPostData: {
        thumbnail: false,
        thumbnail2: false,
        imageFile: null,
        imageName: "",
        imageUrl: "",
        videoFile: null,
        text: "",
        tags: [],
        user_id: null,
      },
      Comment: {
        imageFile: null,
        imageName: "",
        imageUrl: "",
        videoFile: null,
        text: "",
        user_id: null,
      },
      imageOptions: {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: false,
      },
      chatList: [],
      chatItems: [],
      feedsData: { data: [] },
      chats: [],
      searchchat: "",
      comment: { text: "" },
      tab_type: "feed",
      intern_filter_worktype: "",
      intern_filter_status_input: false,
      intern_filter_create_by_me: false,
      intern_filter_worktype_onsite_input: false,
      intern_filter_worktype_remote_input: false,
      intern_filter_worktype_hybrid_input: false,
      intern_filter_worktype_flexible_input: false,
      filter_form: {
        showMine: false,
        text: "",
        status: "",
        worktype: [],
        id: null,
        tags: [],
        location: "",
        classes: null,
        url_type: "",
        next_page_url: "",
      },
      worktype_filter: [
        { name: "Flexible", value: "flexible" },
        { name: "Hybrid", value: "hybrid" },
        { name: "On Site", value: "onsite" },
        { name: "Remote", value: "remote" },
      ],
      show_worktype_filter: false,
      showFeedLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "getMeProfile",
      "getSearchResults",
      "getFeedsPosts",
      "getLoader",
    ]),
    isFilteringIntern() {
      let vm = this;
      return (
        vm.filter_form.worktype.length > 0 ||
        vm.filter_form.classes != null ||
        vm.filter_form.id != null ||
        vm.filter_form.tags.length > 0 ||
        vm.filter_form.location > 0 ||
        vm.filter_form.status == "applied" ||
        vm.filter_form.text.length > 0
      );
    },
    me() {
      return this.getMeProfile.user;
    },
    userId() {
      return this.getMeProfile.user.id;
    },
    isCustomer() {
      return this.getMeProfile.user.account_type == 2;
    },
    isName() {
      return this.getMeProfile.user.first_name;
    },
    user() {
      let job = "";
      let country = "";
      let city = "";

      if (this.getMeProfile.employment.length > 0)
        job = this.getMeProfile.employment[0].company.name;
      if (this.getMeProfile.profile.location) {
        if (this.getMeProfile.profile.location.country_id)
          country = this.getMeProfile.profile.location.country.name;
        if (this.getMeProfile.profile.location.city_id)
          city = this.getMeProfile.profile.location.city.name;
      }
      return {
        profile: this.getMeProfile.user.profile_picture,
        names:
          this.getMeProfile.user.first_name +
          " " +
          this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        phone: this.getMeProfile.profile.phone,
        available: "Available from",
        available_from: this.getMeProfile.profile.available_from,
        city: city,
        country: country,
        cover_picture: this.getMeProfile.profile.cover_photo,
        location: this.getMeProfile.profile.address,
        job: job,
      };
    },

    feeds() {
      return this.getFeedsPosts;
    },
  },
  watch: {
    searchchat: function (val) {
      this.$store.dispatch("POST_SEARCH_CONNECTION", { query: val });
    },

    showReactions: (val) => {
      if (!val) this.likes = [];
    },
    $route(to, from) {
      this.getFeeds(this.$route.params.tag);
    },
    "feedsData.data": (data) => {
      // if (data.length) {
      // }
      // // this.isFetching = true
      // else {
      // }
    },
  },
  mounted() {
    let vm = this;
    vm.getInternship("init");
    if (vm.$route.query.show) {
      if (
        vm.$route.query.show === "assignments" ||
        vm.$route.query.show === "lia"
      ) {
        vm.tab_type = "ass";
      } else {
        vm.tab_type = "feed";
      }
    }
    if (vm.$route.query.new) {
      // get host name
      let host = window.location.hostname;
      // get protocol
      let protocol = window.location.protocol;
      vm.postData.text =
        "Please click on link below to answer some questions: \n" +
        protocol +
        "//" +
        host +
        "/" +
        vm.$route.query.path;

      setTimeout(function () {
        // Focus on the text area
        let postText = document.getElementById("new-post-textarea");
        postText.focus();
      }, 0);
    }
    if (vm.$route.query.internship) {
      vm.filter_form.id = vm.$route.query.internship;
      vm.switchTab("ass");
      vm.getInternship("init");
    }
    vm.$store.dispatch("GET_ME_PROFILE_DATA");
    vm.getFeeds(vm.$route.params.tag);
    vm.$nextTick(function () {
      const listElm = document.getElementById("posts");
      if (listElm) {
        listElm.addEventListener("scroll", vm.handleScrolled);
      }
    });
  },
  methods: {
    message(lead) {
      this.newChat = lead.user;
    },
    createPrivateLia() {
      let vm = this;
      if (vm.dont_show_again_private_lia_dialog) {
        vm.$localStorage.set("dont_show_again_private_lia_dialog", true);
      }
      vm.show_add_private_lia_dialog_modal = false;
      vm.show_add_private_lia_modal = true;
    },
    addNewPrivateLia() {
      let vm = this;
      if (vm.$localStorage.get("dont_show_again_private_lia_dialog")) {
        vm.show_add_private_lia_dialog_modal = false;
        vm.show_add_private_lia_modal = true;
      } else {
        vm.show_add_private_lia_dialog_modal = true;
      }
    },
    clearHashtag() {
      let vm = this;
      vm.$router.push({ path: "/feeds" });
      vm.getInternship("init");
    },
    onFeedScoll({ target }) {
      // Modify header according to feed scoll
      let vm = this;
      if (window.innerWidth > 400) {
        vm.header_height = "0px";
        vm.body_height = "100%";
      } else {
        vm.header_height = "41px";
        vm.body_height = "calc(100% - 41px)";
      }
      // Get new feeds on feeds scoll
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (vm.tab_type === "feed") {
          vm.getMoreFeeds();
        } else {
          if (
            !vm.showLoading &&
            vm.internship_data.current_page < vm.internship_data.last_page
          ) {
            vm.getInternship("next");
          }
        }
      }
    },
    clearAllFilters() {
      let vm = this;
      vm.intern_filter_worktype = "";
      vm.intern_filter_status_input = false;
      vm.intern_filter_create_by_me = false;
      vm.filter_form = {
        showMine: false,
        text: "",
        status: "",
        worktype: [],
        tags: [],
        id: null,
        location: "",
        classes: null,
        url_type: "",
        next_page_url: "",
      };
      eventBus.$emit("reset_filter");
      vm.getInternship();
      if (vm.$route.query.internship) {
        vm.$router.push({ path: "/feeds" });
      }
    },
    onSearchInternshipByClass(data) {
      let vm = this;
      vm.filter_form.classes = data;
      vm.getInternship();
    },
    onSearchInternshipByWorktype(data) {
      let vm = this;
      vm.filter_form.worktype = [];
      vm.show_worktype_filter = false;
      data.forEach((type) => {
        if (type == "onsite") {
          [type, "On site", "on site", "On Site", "Onsite", "onsite"].forEach(
            (it) => {
              vm.filter_form.worktype.push(it);
            }
          );
        } else if (type == "remote") {
          [type, "Remote"].forEach((it) => {
            vm.filter_form.worktype.push(it);
          });
        } else if (type == "hybrid") {
          [type, "Hybrid"].forEach((it) => {
            vm.filter_form.worktype.push(it);
          });
        } else if (type == "flexible") {
          [type, "Flexible"].forEach((it) => {
            vm.filter_form.worktype.push(it);
          });
        }
      });
      vm.getInternship();
    },
    onSearchInternshipCreateByMe({ target }) {
      let vm = this;
      if (target.checked) {
        vm.filter_form.showMine = true;
      } else {
        vm.filter_form.showMine = false;
      }
      vm.getInternship();
    },
    onSearchInternshipByStatus({ target }) {
      let vm = this;
      if (target.checked) {
        vm.filter_form.status = "applied";
      } else {
        vm.filter_form.status = "";
      }
      vm.getInternship();
    },
    onSearchInternshipByLocation(data) {
      let vm = this;
      vm.filter_form.location = data;
      vm.getInternship();
    },
    onSearchInternshipByTag(data) {
      let vm = this;
      vm.filter_form.tags = data;
      vm.getInternship();
    },
    searchInternship({ target }) {
      let vm = this;
      vm.filter_form.text = target.value;
      vm.getInternship();
    },
    getInternship(type = "init") {
      let vm = this;
      vm.showLoading = true;
      vm.filter_form.url_type = type;
      vm.filter_form.next_page_url = vm.internship_data
        ? vm.internship_data.next_page_url
        : "";
      vm.$store
        .dispatch("GET_ALL_ASSIGNMENTS", vm.filter_form)
        .then((value) => {
          vm.showLoading = false;
          vm.internship_data.data = value.data.data.map((item) => {
            let roles = item.role;
            let skills = [];
            if (item.user) {
              if (item.user.customer_profile)
                eventBus.$set(
                  item,
                  "customer",
                  item.user.customer_profile.name
                );
              else eventBus.$set(item, "customer", item.user.username);
            } else eventBus.$set(item, "customer", "");

            eventBus.$set(item, "more_skills", false);
            eventBus.$set(item, "address", item.address);
            eventBus.$set(item, "view_more", false);

            item.skills.forEach((skill) => {
              skill.roles.forEach((i) => {
                skills.push(i.name);
              });
              skill.tools.forEach((i) => {
                skills.push(i.name);
              });
              skill.domains.forEach((i) => {
                skills.push(i.name);
              });
              skill.competences.forEach((i) => {
                skills.push(i.name);
              });
              skill.languages.forEach((i) => {
                skills.push(i.name);
              });
            });
            item.roles = roles;
            eventBus.$set(item, "all_skills", skills);
            eventBus.$set(item, "less_skills", skills.slice(0, 3));
            item.skills = item.less_skills;

            return item;
          });
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    validateAccountsType(accounts) {
      if (Array.isArray(accounts)) {
        return true;
      }
      return false;
    },
    notifyUserApplied() {
      let vm = this;
      vm.$notify({
        group: "status",
        title: "Message",
        text: "You already have internship",
        type: "warn",
        duration: 3000,
      });
    },
    selectInternship(item) {
      let vm = this;
      item.loading = true;
      vm.$store
        .dispatch("STUDENT_ACCEPT_INTERNSHIP", {
          user_id: vm.$getLoggedUser().id,
          internship_id: item.id,
          interested: true,
        })
        .then((value) => {
          item.loading = false;
          let logged_user = vm.$getLoggedUser();
          logged_user.has_internship = true;
          vm.$localStorage.set("logged_user_data", JSON.stringify(logged_user));
          vm.getInternship();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Thank you for your feedback",
            type: "success",
            duration: 3000,
          });
        })
        .catch((reason) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    applyInternship(item) {
      let vm = this;
      vm.$store
        .dispatch("APPLY_INTERNSHIP", {
          id: item.id,
          company_id: item.company_id,
        })
        .then((responce) => {
          vm.getInternship();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Now you have applied to internship",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    editPost(post) {
      let vm = this;
      vm.editPostData.thumbnail = false;
      vm.editPostData.thumbnail2 = false;
      vm.editPostData.imageFile = null;
      vm.editPostData.imageName = "";
      if (post.image) {
        vm.editPostData.imageUrl = vm.$fullUrl("images/feeds/" + post.image);
      }
      vm.editPostData.videoFile = null;
      vm.editPostData.text = post.feed;
      vm.editPostData.tags = [];
      vm.editPostData.id = post.id;
      vm.editPostData.user_id = post.user_id;
      vm.showPostEdit = true;
    },
    switchTab(type) {
      this.tab_type = type;
    },
    handleScroll(event) {
      let sticky = document.getElementById("freaking-sticky");
      let offset = sticky.offsetTop;
      this.sticky = window.pageYOffset > offset - 60;

      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      if (bottomOfPage || pageHeight < visible) {
        this.getMoreFeeds();
      }
    },
    handleScrolled(event) { },
    checkLiked(likes) {
      // if (likes.length > 0) {
      //     likes = likes.map(like => like.user.id)
      //     return (likes.indexOf(this.userId) > 0)
      // }
      // else
      return false;
    },
    showLikes(likes) {
      if (likes.length > 0) {
        this.likes = likes;
        console.log(likes);
        this.showReactions = true;
      }
    },
    hideLikes() {
      this.likes = [];
    },
    pickImageFile(isComment) {
      if (isComment) this.$refs.image2.click();
      else this.$refs.image.click();
    },
    pickVideoFile(isComment) {
      if (isComment) this.$refs.video2.click();
      else this.$refs.video.click();
    },
    getHashTags(inputText) {
      var regex = /(?:^|\s)(?:#)([a-zA-Z\d]+)/gm;
      var match;
      while ((match = regex.exec(inputText))) {
        this.postData.tags.push(match[1]);
        this.editPostData.tags.push(match[1]);
      }
    },
    onImagePicked(e) {
      let vm = this;
      const files = e.target.files;
      vm.postData.imageName = files[0].name;
      vm.editPostData.imageName = files[0].name;
      if (files[0] !== undefined) {
        if (vm.postData.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        if (vm.editPostData.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          vm.postData.imageUrl = fr.result;
          vm.editPostData.imageUrl = fr.result;
          imageCompression(files[0], vm.imageOptions)
            .then(function (compressedFile) {
              vm.postData.imageFile = compressedFile;
              vm.editPostData.imageFile = compressedFile;
            })
            .catch(function (error) {
              vm.removeImage();
              console.error(error.message);
            });
        });
      } else {
        vm.postData.imageFile = null;
        vm.editPostData.imageFile = null;
      }
    },
    removeImagee() {
      this.postData.thumbnail = false;
      this.postData.thumbnail2 = false;
      (this.postData.imageFile = null), (this.postData.imageName = "");
      this.postData.imageUrl = "";
      this.postData.videoFile = null;
      this.postData.text = "";
      this.postData.tags = [];
      this.postData.user_id = null;
    },
    onVideoPicked(e) {
      let vm = this;
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          vm.postData.videoFile = files[0];
          vm.postData.thumbnail = true;
          vm.editPostData.videoFile = files[0];
          vm.editPostData.thumbnail = true;
        });
      } else {
        this.postData.videoFile = null;
        vm.editPostData.videoFile = null;
      }
    },
    onImagePicked2(e) {
      let vm = this;
      const files = e.target.files;
      vm.postData.imageName = files[0].name;
      if (files[0] !== undefined) {
        if (vm.postData.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          vm.postData.imageUrl = fr.result;
          imageCompression(files[0], vm.imageOptions)
            .then(function (compressedFile) {
              vm.postData.imageFile = compressedFile;
            })
            .catch(function (error) {
              vm.removeImage();
              console.error(error.message);
            });
        });
      } else {
        this.postData.imageFile = null;
      }
    },
    onVideoPicked2(e) {
      let vm = this;
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          vm.postData.videoFile = files[0];
        });
      } else {
        this.postData.videoFile = null;
      }
    },
    removeImage() {
      this.postData.imageFile = null;
      this.postData.imageName = "";
      this.postData.imageUrl = "";
      this.postData.text = "";

      this.editPostData.imageFile = null;
      this.editPostData.imageName = "";
      this.editPostData.imageUrl = "";
    },
    saveEditedPost() {
      let vm = this;
      if (
        (vm.editPostData.text.trim() !== "" && vm.editPostData.text) ||
        vm.postData.imageFile ||
        vm.postData.videoFile
      ) {
        let postFrmData = new FormData();
        vm.getHashTags(vm.editPostData.text);
        vm.editPostData.tags.forEach((tag) => {
          vm.editPostData.text = vm.editPostData.text.replace(
            "#" + tag,
            "<span style='color: #1885AD'>#" + tag + "</span>"
          );
        });
        postFrmData.append("id", vm.editPostData.id);
        postFrmData.append("user_id", vm.editPostData.user_id);
        postFrmData.append("feed", vm.editPostData.text);
        postFrmData.append("tags", vm.editPostData.tags);

        if (vm.postData.imageFile) {
          postFrmData.append(
            "image",
            vm.postData.imageFile,
            vm.postData.imageName
          );
        }

        if (vm.postData.videoFile) {
          postFrmData.append("video", vm.postData.videoFile);
        }
        vm.$store
          .dispatch("EDIT_POST", postFrmData)
          .then((response) => {
            vm.resetPost();
            vm.getFeeds();
            vm.showPostEdit = false;
            vm.$router.push("/feeds");
          })
          .catch((error) => {
            console.error(error);
          });

        vm.removeImage();
      } else {
        vm.isEmpty = true;
      }
    },
    savePost() {
      let vm = this;
      if (
        (vm.postData.text.trim() !== "" && vm.postData.text) ||
        vm.postData.imageFile ||
        vm.postData.videoFile
      ) {
        let postFrmData = new FormData();
        vm.getHashTags(vm.postData.text);
        vm.postData.tags.forEach((tag) => {
          vm.postData.text = vm.postData.text.replace(
            "#" + tag,
            "<span style='color: #1885AD'>#" + tag + "</span>"
          );
        });
        postFrmData.append("feed", vm.postData.text);
        postFrmData.append("tags", vm.postData.tags);

        if (vm.postData.imageFile)
          postFrmData.append(
            "image",
            vm.postData.imageFile,
            vm.postData.imageName
          );

        if (vm.postData.videoFile)
          postFrmData.append("video", vm.postData.videoFile);

        // vm.$store.dispatch("POST_FEED_POST", postFrmData);
        vm.$store.dispatch("LOADER_START");
        axios({
          url: API + POST_FEED_POST_URL,
          method: "POST",
          data: postFrmData,
          headers: { Authorization: "Bearer " + sessionStorage.authToken },
        })
          .then((response) => {
            vm.$store.dispatch("LOADER_CLOSE");
            vm.getFeeds();
            vm.$router.push("/feeds");
          })
          .catch((error) => {
            vm.$store.dispatch("LOADER_CLOSE");
            console.error(error);
          });

        vm.removeImage();
      } else {
        vm.isEmpty = true;
      }
    },
    resetPost() {
      let vm = this;
      vm.postData = {
        thumbnail: false,
        thumbnail2: false,
        imageFile: null,
        imageName: "",
        imageUrl: "",
        videoFile: null,
        text: "",
        tags: [],
        user_id: null,
      };
      vm.editPostData = {
        thumbnail: false,
        thumbnail2: false,
        imageFile: null,
        imageName: "",
        imageUrl: "",
        videoFile: null,
        text: "",
        tags: [],
        user_id: null,
      };
    },
    saveComment(comment, index, feed) {
      let vm = this;
      let obj = this.feedsData.data[index].comments[0];
      if (comment.trim() !== "") {
        axios({
          url: API + POST_FEED_COMMENT_URL,
          method: "POST",
          data: {
            comment: comment,
            feed: feed.id,
            type: "Feed",
            id: feed.id,
          },
          headers: { Authorization: "Bearer " + sessionStorage.authToken },
        })
          .then((response) => {
            vm.feedsData.data[index].text = "";
            vm.getFeeds();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    feedLike(post) {
      let vm = this;
      let liked = false;
      let data = {
        type: "Feed",
        id: post.id,
        user_id: post.user_id,
      };
      axios({
        url: API + POST_FEED_LIKE_URL,
        method: "POST",
        data: data,
        headers: { Authorization: "Bearer " + sessionStorage.authToken },
      })
        .then((response) => {
          eventBus.$set(post, "likes", response.data);
          if (response.data.length > 0) {
            let likes = response.data.map((like) => like.user_id);
            liked = likes.indexOf(vm.userId) > -1;
          } else {
            liked = false;
          }
          eventBus.$set(post, "liked", liked);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    commentLike(comment) {
      let data = {
        type: "Comment",
        id: comment.id,
        user_id: comment.user_id,
      };
      axios({
        url: API + POST_FEED_LIKE_URL,
        method: "POST",
        data: data,
        headers: { Authorization: "Bearer " + sessionStorage.authToken },
      })
        .then((response) => {
          eventBus.$set(comment, "likes", response.data);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    showComment(post) {
      eventBus.$set(post, "showComment", !post.showComment);
      return post.showComment;
    },
    removeComment(id, index, comments) {
      comments.splice(index, 1);
      this.$store.dispatch("REMOVE_FEED_COMMENT", { id: id });
    },
    infiniteScroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop +
          document.documentElement.offsetHeight ===
          document.documentElement.scrollHeight;

        if (bottomOfWindow) {
          this.$store.dispatch("LOADER_MORE_FEEDS", true);
          this.$store.dispatch("GET_MORE_FEEDS_POSTS");
          this.getMoreFeeds();
        }
      };
    },
    getFeedsbyTag(name) {
      this.$destroy();
      this.$router.push({ name: "tags", params: { tag: name } });
    },
    getFeeds(tag = "") {
      let vm = this;
      vm.showFeedLoading = true;
      // Check if user id is loaded
      if (vm.userId) {
        axios({
          url: API + GET_FEEDS_POSTS_URL + tag,
          method: "GET",
          headers: { Authorization: "Bearer " + sessionStorage.authToken },
        })
          .then((response) => {
            vm.showFeedLoading = false;
            vm.feedsData = response.data;
            vm.feedsData.data = response.data.data
              .map(function (item) {
                if (item.user) {
                  if (item.likes.length > 0) {
                    let likes = item.likes.map((like) => {
                      if (like.user) {
                        return like.user.id;
                      }
                    });
                    eventBus.$set(item, "liked", likes.indexOf(vm.userId) > -1);
                  } else eventBus.$set(item, "liked", false);
                  item.comments.map((comment) => {
                    if (comment.user) {
                      return comment;
                    }
                  });
                  if (item.user === null) eventBus.$set(item, "user", {});
                  else eventBus.$set(item, "user", item.user);

                  eventBus.$set(item, "showComment", false);
                  eventBus.$set(item, "showOption", false);
                  eventBus.$set(item, "text", "");
                  return item;
                }
              })
              .filter((item) => {
                return item;
              });
          })
          .catch((error) => {
            vm.showFeedLoading = false;
          });
      } else {
        setTimeout(() => {
          vm.getFeeds();
        }, 500);
      }
    },
    getMoreFeeds() {
      let vm = this;
      vm.showFeedLoading = true;
      axios({
        url: this.feedsData.next_page_url,
        method: "GET",
        headers: { Authorization: "Bearer " + sessionStorage.authToken },
      })
        .then((response) => {
          vm.showFeedLoading = false;
          let data = response.data.data
            .map(function (item) {
              if (item.user) {
                if (item.likes.length > 0) {
                  let likes = item.likes.map((like) => {
                    if (like.user) {
                      return like.user.id;
                    }
                  });
                  eventBus.$set(item, "liked", likes.indexOf(vm.userId) > -1);
                } else eventBus.$set(item, "liked", false);

                item.comments.map((comment) => {
                  if (comment.user) {
                    return comment;
                  }
                });

                eventBus.$set(item, "showComment", false);
                eventBus.$set(item, "showOption", false);
                eventBus.$set(item, "text", "");
                return item;
              }
            })
            .filter((item) => {
              return item;
            });
          data.forEach((item) => {
            if (item.user) {
              vm.feedsData.data.push(item);
            }
          });
          vm.feedsData.next_page_url = response.data.next_page_url;
        })
        .catch((error) => {
          vm.showFeedLoading = false;
        });
    },
    deletePost(id, index) {
      this.$store.dispatch("DELETE_FEED_POST", { id: id });
      this.feedsData.data.splice(index, 1);
    },
  },
  updated() {
    let el = this.$el.querySelector("#comment-parent");
    if (el !== null && el !== undefined) el.scrollTop = el.scrollHeight;
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.stick {
  position: fixed !important;
  top: 60px;
  width: 150px;

  @media (min-width: 300px) and (max-width: 630px) {
    position: unset;
    width: inherit;
  }
}

.stick__r {
  position: fixed !important;
  top: 60px;
  width: 180px;

  @media (min-width: 300px) and (max-width: 630px) {
    position: relative !important;
    width: inherit;
  }
}

.liked {
  color: #1885ad !important;
}

.__wrapper {
  background: rgba(239, 239, 239, 0.49);
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  padding-top: 55px;
  display: flex;
  flex-direction: column;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 50px;
  }

  .__head {
    height: 55px;
    background-image: url("../assets/images/backgrounds/wallpaper.svg");
    background-size: cover;
    transition: 200ms ease-in;
    display: none;
    /*@media (min-width: 300px) and (max-width: 630px) {*/
    /*    display: none;*/
    /*}*/
  }

  .__body {
    height: 100%;
    overflow-y: auto;
    transition: 200ms ease-in;
    padding-top: 8px;
    margin-bottom: 5px;

    @media (min-width: 300px) and (max-width: 630px) {
      padding-top: 0px;
    }

    .__container {
      margin: 0 auto;
      width: 782px;
      display: grid;
      grid-template-columns: 594px 180px;
      grid-column-gap: 8px;

      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 1fr;
        width: 100%;
      }

      .__section-center {
        min-width: 0;

        .section-center__layout {
          display: grid;
          grid-column-gap: 8px;
          grid-template-columns: 200px 386px;
          min-width: 0;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 1fr;
          }

          .layout__left {
            min-width: 0;

            .left-sidebar {
              position: sticky;
              top: 0px;
            }

            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }

            h2 {
              color: #535353;
              margin-top: 20px;
              margin-left: 10px;
              font-size: 23px;
            }

            a:hover {
              text-decoration: none !important;
            }

            .item-row {
              padding: 10px 20px;

              &:hover {
                background: #1890a9;
                color: #fff;

                span {
                  color: #fff;
                }
              }

              img {
                margin-right: 10px;
              }

              span {
                color: #797979;
                font-size: 14px;
                font-weight: normal;
              }

              .fin {
                float: right;
                font-weight: bold;
                margin-top: 2px;
                margin-right: 0 !important;
                font-size: 12px;
              }
            }

            .item-row-active {
              background: #1890a9;
            }

            .__title {
              background: #0884af;
              padding: 5px 10px;

              span {
                font-size: 16px;
                color: #fff;
              }
            }

            .__card_body {
              display: flex;
              padding: 0 10px;
              flex-direction: column;

              h3 {
                font-size: 15px;
                color: #4e4e4e;
                font-weight: normal;
                margin-top: 10px;
                margin-bottom: 20px;
              }

              .__item {
                margin-bottom: 10px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;

                &.bold {
                  label {
                    font-weight: 800;
                  }
                }

                label {
                  color: #0884af;
                  font-size: 13px;
                  cursor: pointer;
                  margin-right: 10px;
                  font-weight: normal;
                }
              }

              .reset-hashtag-widget {
                border-top: 1px solid #ddd;
                padding: 10px 0px;

                .btn-clear-hashtag {
                  color: #1ba5a4;
                }
              }
            }

            .contact-card {
              display: flex;
              flex-direction: column;

              .section {
                width: 100%;
                display: flex;
                padding: 30px 0;
                justify-content: center;
                align-items: center;
                border-bottom: 2px solid #f5f5f5;
                flex-direction: column;

                img {
                  width: 60px;
                  height: 60px;
                  cursor: pointer;
                  margin-top: 0px;
                  border-radius: 100%;
                  object-fit: cover;
                }

                h2 {
                  color: #000000 !important;
                  text-align: center;
                  margin-top: 19px !important;
                  font-size: 16px;
                  font-family: "Nunito";
                  font-weight: 400;
                  text-align: center;
                }

                span {
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  text-align: center;
                  color: #707070;
                  text-align: center;
                  margin-top: 8px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: block;
                  width: 80%;
                }

                label {
                  font-size: 14px;
                  text-align: center;
                  margin-top: 10px;
                  color: #808080;
                }
              }

              .sec {
                border-bottom: 0px solid #f5f5f5;
                padding-top: 0;

                span {
                  color: #808080;
                  text-align: center;
                  font-size: 13px;
                }
              }
            }

            .__suggestion-box {
              .__card_body {
                margin-top: 0px;
                background: transparent;

                .__item {
                  display: flex;
                  margin-bottom: 20px;
                  flex-direction: row;

                  img,
                  .__logo {
                    width: 25px;
                    height: 25px;
                    border-radius: 100%;
                  }

                  .__logo {
                    background: #1885ad;
                    padding: 0 !important;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    span {
                      color: #fff;
                      font-size: 42px;
                      margin: 0 0 12px 12px;
                      font-weight: normal;
                    }
                  }

                  .__centered {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    margin-left: 10px;
                    justify-content: space-between;

                    .__text {
                      display: flex;
                      flex-direction: column;

                      h3 {
                        margin-bottom: 0;
                        font-weight: normal;
                        font-size: 13px;
                        cursor: pointer;
                      }

                      span {
                        margin-top: -5px;
                        font-size: 10px;
                      }

                      .__greyed {
                        color: #000;
                        cursor: default;
                      }

                      label {
                        font-size: 11px;
                      }
                    }

                    img {
                      padding: 5px;
                      border-radius: 100px;
                      width: 20px;
                      height: 20px;
                      background: #ececef;
                    }
                  }
                }

                .vertical {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;

                  span {
                    color: #959595;
                    font-size: 13px;
                    text-decoration: underline;
                    cursor: pointer;
                    margin: 10px 0px;
                    font-weight: normal;
                    text-align: center;
                  }

                  h1 {
                    color: #959595;
                    font-size: 19px;
                    opacity: 0.6;
                    font-weight: normal;
                  }

                  label {
                    font-size: 11px;
                    font-weight: normal;
                    margin-top: 0px;
                    color: #959595;
                  }

                  img {
                    margin-top: 0px;
                  }
                }
              }
            }

            .forum-widget {
              .forum-btn {
                width: 93%;
                height: 35px;
                background: #04a5a5 0% 0% no-repeat padding-box;
                border-radius: 5px;
                display: flex;
                color: #fff;
                align-items: center;
                justify-content: center;
              }
            }
          }

          .layout__right {
            min-width: 0;

            .box {
              // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
              border-radius: 5px;
              background-attachment: #fff;

              .post-tabs {
                display: flex;
                justify-content: space-between;
                background: #cccccc;
                border-radius: 5px 5px 0px 0px;

                @media (min-width: 300px) and (max-width: 630px) {
                  border-radius: 0px;
                }

                .tab-item {
                  height: 40px;
                  width: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #fff;
                  cursor: pointer;
                  transition: 300ms ease-in;
                }

                .feed-tab.active {
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  text-align: center;
                  color: #1ba5a4;
                  background: #fff;
                  border-radius: 5px 0px 0px 0px;
                  transition: 300ms ease-in;

                  @media (min-width: 300px) and (max-width: 630px) {
                    border-radius: 0px;
                  }
                }

                .ass-tab.active {
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  text-align: center;
                  color: #1ba5a4;
                  background: #fff;
                  border-radius: 0px 5px 0px 0px;
                  transition: 300ms ease-in;
                }
              }

              .__post-box {
                width: 100%;
                background: #fff;
                position: relative;
                padding: 10px 10px 10px 10px;
                border-radius: 0px 0px 5px 5px;

                @media (min-width: 300px) and (max-width: 630px) {
                  border-radius: 0px;
                }

                .input__post {
                  display: flex;

                  img {
                    width: 40px;
                    max-height: 40px;
                    border-radius: 100%;
                    margin-right: 10px;
                  }

                  textarea {
                    font-size: 14px;
                    opacity: 0.8;
                    width: 100%;
                    resize: none;
                    min-height: 45px !important;
                    max-height: 150px !important;
                    outline: none;
                    color: #535353;
                    font-weight: normal;
                    transition: 400ms ease-in;
                    height: 45px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    padding: 10px;
                    transition: 400ms ease-in;
                    width: 100%;

                    &:hover {
                      outline: none;
                    }

                    &:focus {
                      height: 150px;
                      margin-bottom: 10px;
                      padding: 10px;
                      transition: 400ms ease-in;
                      width: 100%;
                    }

                    &.new {
                      height: 150px;
                      margin-bottom: 10px;
                      padding: 10px;
                      transition: 400ms ease-in;
                      width: 100%;
                    }
                  }
                }

                .post {
                  display: flex;
                  flex-direction: column;

                  img {
                    max-width: 100%;
                    border-radius: 10px;
                  }
                }

                .__actions {
                  display: flex;
                  width: 100%;
                  padding-top: 8px;
                  justify-content: space-between;
                  align-items: center;

                  .btn-cancel {
                    color: #0884af;
                    font-weight: bold;
                  }

                  .btn-select {
                    display: flex;
                    align-items: center;
                    font-family: "Nunito";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 13px;
                    text-align: center;
                    color: #1ba5a4;
                    background: #f3f3f3;
                    border-radius: 5px;
                    height: 30px;
                    padding: 0px 10px;

                    img {
                      width: 13px;
                      height: 13px;
                      margin-right: 4px;
                    }
                  }

                  .btn-post {
                    background: #0884af;
                    justify-content: center;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                    cursor: pointer;
                    height: 40px;
                    padding: 0px 23px;
                    color: #fff;
                    font-weight: bold;

                    &.disabled {
                      background: #d9d9d9;
                      cursor: not-allowed;
                    }

                    img {
                      margin-left: 5px;
                    }
                  }
                }
              }
            }

            .__post-item {
              margin-top: 10px;
              background: #fff;
              position: relative;
              padding: 10px 0 0 0;
              border-radius: 5px;

              @media (min-width: 300px) and (max-width: 630px) {
                border-radius: 0px;
              }

              .__header {
                display: flex;
                padding: 0 10px 10px 10px;
                /*border-bottom: 2px solid #F5F5F5;*/
                flex-direction: row;
                justify-content: space-between;

                .group {
                  display: flex;
                  padding: 0;
                  align-items: center;

                  img {
                    width: 43px;
                    height: 43px;
                    border-radius: 100%;
                    object-fit: cover;
                    cursor: pointer;
                  }

                  .__time {
                    display: flex;
                    margin-left: 10px;
                    margin-top: -5px;
                    flex-direction: column;

                    span {
                      color: #b3b3b3;
                      font-weight: normal;
                      font-size: 14px;
                    }

                    label {
                      color: #4e4e4e;
                      margin-top: 5px;
                      font-weight: normal;
                      font-size: 14px;
                    }
                  }
                }

                .options {
                  position: relative;

                  img {
                    cursor: pointer;
                    transform: rotate(90deg);
                  }

                  .items {
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
                    background: #fff;
                    position: absolute;
                    right: 0;
                    top: 25px;
                    padding: 10px 20px;

                    span {
                      cursor: pointer;

                      &:hover {
                        color: #04a5a5;
                      }
                    }
                  }
                }
              }

              .__paragraph {
                max-width: 100%;
                font-size: 14px;
                color: #4e4e4e;
                padding: 10px;
                line-height: 20px;
                font-weight: normal;
                text-align: left;

                img,
                video {
                  width: 100% !important;
                  max-height: 400px;
                  border-radius: 10px;
                  object-fit: cover;
                }

                .feed-content {
                  white-space: pre-wrap;
                }
              }

              .__actions {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                margin: 0 10px;
                height: 40px;
                border-top: 2px solid #f5f5f5;
                border-bottom: 2px solid #f5f5f5;
                margin-bottom: 10px;

                .__likes {
                  display: flex;
                  cursor: pointer;
                  align-items: center;

                  .btn-like {
                    background: #f3f3f3;
                    border-radius: 5px;
                    width: 23px;
                    height: 23px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease-in-out;
                    transform: scale(1);

                    &:hover {
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
                      transition: all 0.3s ease-in-out;
                      transform: scale(1.1);
                    }

                    img.like-img {
                      width: 15px !important;
                      height: 15px !important;
                    }
                  }

                  .likes-widget {
                    display: flex;
                    margin-left: 8px;

                    .likes-profile {
                      display: flex;
                      align-items: center;

                      img.profile-image {
                        height: 19px;
                        width: 19px;
                        border-radius: 50%;
                        border: 2px solid #fff;

                        &.many {
                          margin-left: -8px;
                        }
                      }

                      span.names {
                        background: #1ba5a4;
                        border-radius: 9px;
                        display: flex;
                        align-items: center;
                        color: #fff;
                        font-size: 11px;
                        padding: 2px 10px;
                        margin-left: 3px;
                      }
                    }
                  }

                  span.likes-left-count {
                    color: #999999;
                    margin-left: 5px;
                    font-size: 12px;

                    span.link {
                      color: #0884ad;
                      cursor: pointer;
                    }
                  }
                }

                ._comments {
                  display: flex;
                  cursor: pointer;
                  align-items: center;

                  .btn-comments {
                    margin-right: 3px;
                    background: #f3f3f3;
                    border-radius: 5px;
                    width: 23px;
                    height: 23px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease-in-out;
                    transform: scale(1);

                    &:hover {
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
                      transition: all 0.3s ease-in-out;
                      transform: scale(1.1);
                    }

                    &.active {
                      background: #0884af;
                    }

                    img.comment {
                      width: 15px !important;
                      height: 15px !important;
                    }
                  }

                  span {
                    position: relative;
                    top: 1px;
                    font-size: 12px;
                  }
                }
              }

              .show-comments {
                display: flex;
                cursor: pointer;
                justify-content: center;
                align-items: center;
                background: #efefef;
                padding: 8px;

                span {
                  color: #b3b3b3;
                }
              }

              .__comments {
                max-height: 320px;
                padding: 0 20px;
                overflow: auto;

                &::-webkit-scrollbar {
                  background-color: transparent;
                  width: 12px;
                }

                &::-webkit-scrollbar-track {
                  background-color: transparent;
                }

                /* scrollbar itself */
                &::-webkit-scrollbar-thumb {
                  background-color: #babac0;
                  border-radius: 16px;
                  border: 4px solid #f2f2f2;
                }

                &::-webkit-scrollbar-button {
                  display: none;
                }

                .__coment {
                  display: flex;
                  flex-direction: row;
                  margin-top: 10px;
                  width: 100%;
                  position: relative;

                  .comment-dropdown {
                    position: absolute;
                    right: 0px;
                    padding: 0px 9px;

                    button {
                      background: transparent;
                      border: none;
                      outline: none;

                      img {
                        width: 10px;
                        height: 10px;
                      }
                    }
                  }

                  img {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    object-fit: cover;
                  }

                  .__text {
                    display: flex;
                    margin-left: 10px;
                    padding: 12px 10px;
                    border-radius: 5px;
                    background: #efefef;
                    width: 100%;
                    flex-direction: column;

                    h6 {
                      font-weight: normal;
                      margin-bottom: 0;
                      font-size: 14px;
                    }

                    p {
                      font-weight: normal;
                      margin-bottom: 0;
                      font-size: 14px;
                    }

                    h6 {
                      margin-bottom: 2px;
                      font-size: 14px;
                      line-height: 10px;
                      font-weight: normal;
                      color: #000000;

                      span {
                        color: #b3b3b3;
                        cursor: pointer;
                        margin-left: 10px;
                        font-size: 11px;
                      }
                    }

                    p {
                      color: #535151;
                      margin-bottom: 10px;
                      margin-top: 6px;
                    }

                    .__actions {
                      display: flex;
                      flex-direction: row;
                      padding: 0;
                      margin: 0;
                      border: none;
                      justify-content: space-between;
                      width: 30%;

                      span {
                        color: #999999;
                        cursor: pointer;
                        font-size: 12px;
                      }

                      .__green {
                        color: #0884af;
                      }
                    }
                  }
                }
              }

              .__comments-wrapper {
                display: flex;
                flex-direction: column;
                margin-top: 10px;
                margin-bottom: 10px;

                .__comment__post-box {
                  padding: 6px 20px;
                  display: flex;

                  @media (min-width: 300px) and (max-width: 630px) {
                    border-radius: 0px;
                  }

                  img {
                    width: 30px;
                    border-radius: 100%;
                    height: 30px;
                    margin-right: 10px;
                    object-fit: cover;
                  }

                  textarea {
                    width: 100%;
                    outline: none;
                    font-size: 13px;
                    background: none;
                    height: 35px;
                    color: rgb(99, 99, 99);
                    overflow-wrap: break-word;
                    padding: 6px 10px;
                    transition: 400ms ease-in;
                    resize: none;
                    border: 1px solid #d5d5d5;
                    border-radius: 5px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      padding: 6px 10px;
                    }
                  }

                  textarea:focus,
                  textarea:hover {
                    height: 100px;
                    transition: 400ms ease-in;
                    background: #fff;
                  }
                }
              }

              .__reactions {
                display: flex;
                width: 100%;
                margin-top: 10px;
                padding: 10px 20px;
                flex-direction: row;

                .btn-post {
                  width: 40px;
                  height: 40px;
                  margin-top: -5px;
                  background: #04a5a5;
                  justify-content: center;
                  display: flex;
                  border-radius: 100%;
                  cursor: pointer;
                }

                .__actions__ {
                  display: flex;
                  margin-right: 20px;

                  .__icon {
                    width: 20px;
                    height: 20px;
                    margin-right: 40%;

                    img {
                      width: 20px;
                      cursor: pointer;
                      height: 20px;
                    }
                  }
                }
              }
            }

            .loader {
              height: 80px;
              margin-top: 10px;
              background: #fff;
              position: relative;
              padding: 10px 0 0 0;
              border-radius: 5px;

              svg {
                width: 70px !important;
              }
            }

            .feed-loading-widget {
              border-radius: 10px;
              background: #fff;
            }
          }
        }
      }

      .__section-right {
        position: relative;
        width: 100%;
        min-width: 0;

        @media (min-width: 300px) and (max-width: 630px) {
          top: 20px;
        }

        display: flex;
        flex-direction: column;

        .right-sidebar {
          position: sticky;
          top: 0px;

          img {
            border-radius: 5px;

            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
          }
        }

        .long {
          display: flex;
          flex-direction: column;

          img {
            margin-bottom: 10px;
            max-width: 100%;
          }
        }

        img {
          margin-bottom: 10px;
          max-width: 100%;
        }
      }
    }

    .floater {
      position: fixed;
      bottom: 0px;
      right: 10px;
      z-index: 999;
    }

    .__menus {
      display: none;

      @media (min-width: 300px) and (max-width: 630px) {
        display: grid;
        width: 100%;
        background: #f5f9fc !important;
        position: fixed;
        bottom: 0;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 1px;
      }

      span {
        padding: 10px;
        text-align: center;
        color: #1885ad;
      }

      .__activee {
        background: #1885ad;
        color: #fff;
      }
    }
  }

  .overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: rgba($color: #000000, $alpha: 0.7);
    padding: 100px 0px;
    overflow-y: auto;

    @media (min-width: 300px) and (max-width: 630px) {
      padding: 0px 0px;
      padding-top: 55px;
      padding-bottom: 50px;
    }

    .card__body {
      background: #fff;
      width: 500px;
      max-height: 560px;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 0 auto;
      padding: 0px;

      @media (min-width: 300px) and (max-width: 630px) {
        max-height: unset;
        height: 100%;
        width: 100%;
        border-radius: 0px;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px solid #ddd;
        padding: 0px 15px;

        h2 {
          color: #000;
          margin: 0px;
          font-size: 15px;
        }

        .btn-close {
          font-size: 30px;
        }
      }

      .body {
        overflow-y: auto;
        height: calc(100% - 50px);
        padding: 10px 15px;

        .item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;

          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 8px;
          }

          .user-info {
            p {
              margin: 0px;
            }
          }
        }
      }
    }

    .edit-post-widget {
      background: #fff;
      width: 500px;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 0 auto;

      .__post-box {
        width: 100%;
        position: relative;
        padding: 10px 10px 10px 10px;
        border-radius: 0px 0px 5px 5px;

        @media (min-width: 300px) and (max-width: 630px) {
          border-radius: 0px;
        }

        .input__post {
          display: flex;

          img {
            width: 40px;
            max-height: 40px;
            border-radius: 100%;
            margin-right: 10px;
          }

          textarea {
            font-size: 14px;
            opacity: 0.8;
            width: 100%;
            resize: none;
            min-height: 180px !important;
            max-height: 200px !important;
            outline: none;
            color: #535353;
            font-weight: normal;
            transition: 400ms ease-in;
            height: 180px;
            border: 1px solid #eeeeee;
            margin-bottom: 10px;
            border-radius: 5px;
            padding: 10px;
            transition: 400ms ease-in;
            width: 100%;

            &:hover {
              outline: none;
            }
          }

          textarea:focus {
            height: 200px;
            border: 1px solid #f7f7f7;
            margin-bottom: 10px;
            border-radius: 5px;
            padding: 10px;
            transition: 400ms ease-in;
            width: 100%;
          }
        }

        .post {
          display: flex;
          flex-direction: column;

          img {
            max-width: 100%;
            border-radius: 5px;
          }

          .post-cancel {
            display: flex;
            padding: 10px 1px 10px 0;
            justify-content: space-between;

            button {
              color: #0884af;
              outline: none;
              font-weight: bold;
            }
          }
        }

        .__actions {
          display: flex;
          width: 100%;
          padding: 5px 0px 0px 0px;
          justify-content: space-between;
          flex-direction: row;

          .btn-post {
            background: #04a5a5;
            justify-content: center;
            display: flex;
            align-items: center;
            border-radius: 100%;
            cursor: pointer;

            img {
              width: 61px;
            }
          }

          .icons {
            display: flex;

            .__icon {
              width: 20px;
              height: 20px;

              img {
                width: 18px;
                cursor: pointer;
                height: 18px;
              }
            }
          }
        }
      }
    }
  }
}

.__colored {
  color: #1890a9;
}

.__green {
  color: #1ba5a4;
}

.__white {
  color: #ffffff;
}

.__v-space {
  margin-top: 15px !important;
}

.error {
  border: 1px solid maroon !important;
}

.__card {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}

.alumni-widget {
  .btn-alumni {
    background: #1ba5a4;
    border-radius: 5px;
    color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;

    img {
      margin-right: 10px;
    }
  }
}

.less {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.lesss {
  padding: 0 !important;
  border-radius: 5px !important;
  margin-bottom: 10px;
}

.greyed {
  background: #f8f8f8;
}

a {
  text-decoration: none;
}

.all-assignment {
  min-width: calc(100% - 700px);
  width: 100%;
  border-radius: 5px;
  display: flex;

  .all-assignment-container {
    display: flex;
    flex-direction: column;
    width: 100%;

    .assignments-header {
      background: #fff;
      border-radius: 5px;
      padding: 10px;
      padding-bottom: 0px;
      width: 100%;
      margin-bottom: 10px;

      .search-add-btn-widget {
        display: flex;
        justify-content: space-between;

        .search-widget {
          border: 1px solid #ddd;
          height: 35px;
          width: 100%;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;

          img {
            width: 15px;
            height: 15px;
          }

          input {
            height: 42px;
            width: 100%;
            padding-left: 15px;
            outline: none;
            border: none;
            font-family: "Nunito";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #707070;
          }
        }
      }

      .filter-widget {
        display: flex;
        flex-direction: column;

        .filter-widget-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0px;

          .left-section {
            img {
              width: 12px;
              margin-left: 6px;
            }
          }
        }

        .btn-dropdown {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 10px;
          width: 140px;
          height: 35px;
          border: 1px solid #ddd;
          border-radius: 5px;
        }

        .btn-clear-filter {
          color: #0884ad;
        }
      }
    }

    .assingment-body {
      .loader {
        height: 80px;
        margin-top: 10px;
        background: #fff;
        position: relative;
        padding: 10px 0 0 0;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
        border-radius: 5px;
        margin-bottom: 20px;

        svg {
          width: 70px !important;
        }
      }

      ul.assignments-items {
        list-style: none;
        padding-left: 0px;
        margin: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

        @media (min-width: 300px) and (max-width: 630px) {
          padding: 0px 0px;
        }

        .internship-loading-widget {
          position: relative;
          height: 200px;
          width: 100%;
          margin-top: 20px;
          border-radius: 10px;
        }
      }

      .empty-widget {
        background: #fff;
        padding: 20px;

        .empty-widget-body {
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          p {
            text-align: center;
            width: 270px;
          }

          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
  }
}

.empty-widget {
  display: flex;
  align-content: center;
  justify-content: center;

  h1 {
    font-size: 20px;
    color: #ddd;
    margin-top: 200px;
  }
}
</style>